/**
 * Global 404 not found page, could / should be integrated into platform after insights alpha / beta
 *
 * @author Matthew Rawson @ 07/02/2018 15:32
 * @description
 * @notes
 */
import React, {Component} from "react"
import styled from "styled-components"

import id from "@irati/utils/id"
import {H2} from "@irati/ui/src/Headings"
import {Label2 as Label} from "@irati/ui/src/Labels"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"

import Http404Svg from "@irati/ui/src/Errors/Http404.svg"


const ErrorImg = styled.img`
  width: 100px;
  height: 100px;
  ${minWidthMedia.tablet`
    width: auto;
    height: auto;
  `}
`


const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 30px;

  > * {
    margin-bottom: 25px;

    &:last-child {
      margin-top: 15px;
    }
  }

  ${minWidthMedia.tablet`
    padding-top: 60px;

    > * {
      margin-bottom: 30px;
    }
  `}
`


class Unknown extends Component {
  static propTypes = {};
  static defaultProps = {};

  constructor(props) {
    super(props)
    this.state = {
      active: false
    }
  }

  componentDidMount() {
    setTimeout(() => this.init(), 300)
  }

  /**
   * A shitty hack to delay the display of the component,
   * this is used in the user survey component auto retry loop, where this error flashes up for a moment in between
   * state cycles
   */
  init() {
    this.setState({active: true})
  }

  render() {
    const idNamespace = id("Unknown", this.props)

    if (!this.state.active) return null

    return (
      <div id={idNamespace}>
        <ErrorWrapper id={id("wrapper", idNamespace)}>
          <ErrorImg src={Http404Svg} alt="Error" />
          <H2 id={id("title", idNamespace)}><FormattedMessage id="insights.userSurvey.unknownError.heading" /></H2>
          <Label id={id("sub-title", idNamespace)}>
            <span><FormattedMessage id="insights.userSurvey.unknownError.label" /></span>
          </Label>
        </ErrorWrapper>
      </div>
    )
  }
}


export default injectIntl(Unknown)
